import type { CustomListProjection } from '@api'

import EditIcon from '@/assets/icons/icon-edit.svg'
import EyeIcon from '@/assets/icons/icon-eye.svg'
import ExpandMoreIcon from '@/assets/icons/icon-more.svg'
import TrashIcon from '@/assets/icons/icon-trash.svg'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx'

export interface CustomListTableActionsProps {
  row: CustomListProjection
  onViewFans: (list: CustomListProjection) => void
  onEdit: (list: CustomListProjection) => void
  onDelete: (list: CustomListProjection) => void
}

export const CustomListTableActions = ({
  row,
  onViewFans,
  onEdit,
  onDelete,
}: CustomListTableActionsProps) => {
  const itemClassNames =
    'h-[32px] gap-[8px] rounded-[6px] px-[16px] py-[8px] hover:bg-primary-500 hover:text-neutral-default disabled:opacity-60'

  return (
    <div className="flex justify-end gap-8">
      <DropdownMenu>
        <DropdownMenuTrigger testId={row.name + '-actions-trigger'}>
          <ExpandMoreIcon className="h-5 w-5" />
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="w-50 px-[5px] py-[8px]"
        >
          <DropdownMenuItem
            onClick={() => onViewFans(row)}
            className={itemClassNames}
            testId="view-button"
          >
            <EyeIcon className="h-4 w-4" />
            View
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => onEdit(row)}
            className={itemClassNames}
            testId="edit-button"
          >
            <EditIcon className="h-4 w-4" />
            Edit
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => onDelete(row)}
            className={itemClassNames}
            testId="delete-button"
          >
            <TrashIcon className="h-4 w-4" />
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
